import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["assetUrl"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { MigrationResult } from './migration-result';
export const migrateV0ToV1 = data => {
  const {
      assetUrl
    } = data,
    dataWithoutAssetUrl = _objectWithoutProperties(data, _excluded);
  return new MigrationResult('v1', _objectSpread(_objectSpread({}, dataWithoutAssetUrl), {}, {
    asset: {
      assetType: assetUrl.includes('videos.datacamp.com') ? 'Video' : 'Image',
      assetUrl
    }
  }));
};
export const migrations = {
  v0: migrateV0ToV1
};
export default migrations;